<script>
// Atalhos rápidos para as ações mais comuns
export default {
  data() {
    return {
      shortcuts: [
        { to: "/clients/create", icon: "bx bx-user-plus", label: "Indicar Cliente" },
        { to: "/network/invite", icon: "bx bx-group", label: "Indicar Corretor" },
        { to: "/experiences", icon: "bx bx-gift", label: "Resgatar experiências" },
        { to: "/contact/new", icon: "bx bx-support", label: "Fale Conosco" },
      ],
    };
  },
};
</script>

<template>
  <div class="card">
    <div class="card-body p-3">
      <h5 class="font-size-15 mb-3">Atalhos rápidos</h5>
      <div class="row mx-n1">
        <div v-for="item in shortcuts" :key="item.to" class="col-6 px-1 mb-2">
          <router-link :to="item.to" class="btn btn-light btn-block py-2 home-shortcut">
            <i :class="item.icon" class="font-size-22 d-block mb-1"></i>
            <span class="font-size-12">{{ item.label }}</span>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.home-shortcut {
  height: 100%;
  white-space: normal;
}
</style>
